export const routes = {
  invoices: {
    list: '/' as const,
    new: '/invoices/new' as const,
    show: (id: string | number) => `/invoices/${id}`,
    edit: (id: string | number) => `/invoices/${id}/edit`,
    patterns: {
      show: '/invoices/:id' as const,
      edit: '/invoices/:id/edit' as const,
    },
  },
}
